import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import {
    Container,
    Typography,
    Card,
    CardContent,
    Button,
    CircularProgress, Box,
} from "@mui/material";
import { Survey, getSurveyById } from "@services/survey.service";
import SectionTitle from "@others/title-section.layout";

const SurveyPage: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const [survey, setSurvey] = useState<Survey | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSurvey = async () => {
            if (!id) return;
            try {
                const data = await getSurveyById(Number(id));
                setSurvey(data);
            } catch (error) {
                console.error(`Erreur lors du chargement de l'enquête ${id}:`, error);
            } finally {
                setLoading(false);
            }
        };

        fetchSurvey();
    }, [id]);

    if (loading) {
        return (
            <Container sx={{ textAlign: "center", mt: 4 }}>
                <CircularProgress />
            </Container>
        );
    }

    if (!survey) {
        return (
            <Container sx={{ mt: 4 }}>
                <Typography variant="h6" color="error">
                    Enquête non trouvée
                </Typography>
                <Button component={Link} to="/les-enquetes" sx={{ mt: 2 }}>
                    Retour aux enquêtes
                </Button>
            </Container>
        );
    }

    return (
        <Container>
            <SectionTitle title={"ESPACE ÉCOUTE DES HABITANTS"} />
            <Button component={Link} to="/les-enquetes" sx={{ mt: 2 }} variant={"contained"}>
                Retour aux enquêtes
            </Button>
            <Card sx={{ mt: 3, mb: 5 }}>
                <CardContent>
                    <Typography variant="h4" component="h1" gutterBottom>
                        {survey.title}
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2 }}>
                        {survey.description}
                    </Typography>
                    <Typography variant="subtitle2" color="textSecondary">
                        Publié le {new Date(survey.createdAt).toLocaleDateString()}
                    </Typography>
                    {/* Vous pouvez ajouter d'autres informations ou intégrer le lien survey.url si nécessaire */}
                    <Box sx={{ display: "flex", justifyContent: "center"}}>
                        <Button
                            variant="contained"
                            component="a"
                            href={survey.url}
                            target="_blank" // Facultatif, ouvre le lien dans un nouvel onglet
                            rel="noopener noreferrer" // Facultatif, sécurité pour les nouveaux onglets
                        >
                            Je participe !
                        </Button>

                    </Box>
                </CardContent>
            </Card>

        </Container>
    );
};

export default SurveyPage;